import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

// ProtectedRoute component for regular user authentication
export const ProtectedRoute = () => {
  const isAuthenticated = !!localStorage.getItem('token');
  
  return isAuthenticated ? <Outlet /> : <Navigate to="/" replace />;
};

// AdminProtectedRoute component for admin authentication
export const AdminProtectedRoute = () => {
  const isAdminAuthenticated = !!localStorage.getItem('adminToken');
  
  return isAdminAuthenticated ? <Outlet /> : <Navigate to="/admin/login" replace />;
};

export default ProtectedRoute;
